import axios from 'axios'
import Vue from 'vue'
import store from '@/store'

import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'

const ORGANIZATIONS_ENDPOINT = `${API_BASE}organizations/`
const MY_ORG_ENDPOINT = `${API_BASE}organizations/my-org/`

export default class OrganizationAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new OrganizationAPI(cls)
  }

  schema() {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = store.state.axiosApi
      .options(`${ORGANIZATIONS_ENDPOINT}`, options)
      .then(response => response.data)
      .then(data => {
        return {
          ...this.cls.fromAPI(data),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'Schema Organization API error',
          rethrowErrors: true,
        }),
      )
    return promise
  }

  list({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),

      // Sorting
      ordering: ApiFilter.create({ key: 'ordering' }),

      // Search
      name: ApiFilter.create({ key: 'name' }),
    }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
    }

    const promise = store.state.axiosApi.get(ORGANIZATIONS_ENDPOINT, options)
    return promise
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List Organizations API error',
          rethrowErrors: true,
        }),
      )
  }

  selectList({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),

      // Sorting
      ordering: ApiFilter.create({ key: 'ordering' }),

      // Search
      name: ApiFilter.create({ key: 'name' }),
    }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
    }

    const promise = store.state.axiosApi.get(`${ORGANIZATIONS_ENDPOINT}/select-list/`, options)
    return promise
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List Organizations API error',
          rethrowErrors: true,
        }),
      )
  }

  retrieve(id) {
    const url = `${ORGANIZATIONS_ENDPOINT}${id}`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = store.state.axiosApi
      .get(url, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Organization Retrieve API Error', rethrowError: true }))
    return promise
  }

  /**
   * Look up the user's organization based on the subdomain.
   */
  getMyOrganization() {
    const options = {
      headers: {
        ...Auth.getHeaders(),
      },
    }

    const promise = store.state.axiosApi.get(MY_ORG_ENDPOINT, options)
    return promise
      .then(res => {
        return this.cls.fromAPI(res.data)
      })
      .catch(
        apiErrorHandler({
          apiName: 'Get My Organization API',
          enable400Alert: false,
          rethrowErrors: true,
        }),
      )
  }
}
